/*! react-dual-listbox - v2.3.0 | 2022 */
/*! For license information please see index.browser.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactDualListbox", ["react"], t) : "object" == typeof exports ? exports.ReactDualListbox = t(require("react")) : e.ReactDualListbox = t(e.React);
}(self, e => (() => {
  var t = {
      579: (e, t, r) => {
        e.exports = r(11).default;
      },
      11: (e, t, r) => {
        "use strict";

        r.d(t, {
          default: () => ue
        });
        var n = r(184),
          o = r.n(n),
          i = r(522),
          l = r.n(i);
        let a = function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
          return crypto.getRandomValues(new Uint8Array(e)).reduce((e, t) => e + ((t &= 63) < 36 ? t.toString(36) : t < 62 ? (t - 26).toString(36).toUpperCase() : t > 62 ? "-" : "_"), "");
        };
        var c = r(697),
          s = r.n(c),
          u = r(787),
          f = r.n(u);
        const p = s().shape({
            moveLeft: s().node.isRequired,
            moveAllLeft: s().node.isRequired,
            moveRight: s().node.isRequired,
            moveAllRight: s().node.isRequired,
            moveDown: s().node,
            moveUp: s().node
          }),
          d = s().shape({
            moveLeft: s().string.isRequired,
            moveAllLeft: s().string.isRequired,
            moveRight: s().string.isRequired,
            moveAllRight: s().string.isRequired,
            availableFilterHeader: s().string,
            availableHeader: s().string,
            moveDown: s().string,
            moveUp: s().string,
            noAvailableOptions: s().string,
            noSelectedOptions: s().string,
            selectedFilterHeader: s().string,
            selectedHeader: s().string
          }),
          v = function (e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          };
        function b(e) {
          return b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, b(e);
        }
        function y(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        function h(e, t) {
          return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, h(e, t);
        }
        function g(e, t) {
          if (t && ("object" === b(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return m(e);
        }
        function m(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function O(e) {
          return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, O(e);
        }
        function w(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        var R = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && h(e, t);
          }(a, e);
          var t,
            r,
            n,
            i,
            l = (n = a, i = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = O(n);
              if (i) {
                var r = O(this).constructor;
                e = Reflect.construct(t, arguments, r);
              } else e = t.apply(this, arguments);
              return g(this, e);
            });
          function a(e) {
            var t;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, a), (t = l.call(this, e)).onClick = t.onClick.bind(m(t)), t;
          }
          return t = a, (r = [{
            key: "onClick",
            value: function () {
              var e = this.props,
                t = e.direction,
                r = e.isMoveAll;
              (0, e.onClick)({
                direction: t,
                isMoveAll: r
              });
            }
          }, {
            key: "getId",
            value: function () {
              var e = this.props,
                t = e.id,
                r = e.direction,
                n = e.isMoveAll;
              return "".concat(t, "-move").concat(n ? "-all" : "", "-").concat(r);
            }
          }, {
            key: "getActionKey",
            value: function () {
              var e = this.props,
                t = e.direction,
                r = e.isMoveAll;
              return "move".concat(r ? "All" : "").concat(v(t));
            }
          }, {
            key: "getLabel",
            value: function () {
              return this.props.lang[this.getActionKey()];
            }
          }, {
            key: "renderIcons",
            value: function () {
              return this.props.icons[this.getActionKey()];
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.direction,
                r = e.disabled,
                n = e.isMoveAll,
                i = this.getId(),
                l = this.getLabel(),
                a = o()(w({
                  "rdl-move": !0,
                  "rdl-move-all": n
                }, "rdl-move-".concat(t), !0));
              return f().createElement("button", {
                "aria-label": l,
                className: a,
                disabled: r,
                id: i,
                title: l,
                type: "button",
                onClick: this.onClick
              }, this.renderIcons());
            }
          }]) && y(t.prototype, r), Object.defineProperty(t, "prototype", {
            writable: !1
          }), a;
        }(f().Component);
        w(R, "propTypes", {
          direction: s().oneOf(["left", "right", "up", "down", "top", "bottom"]).isRequired,
          disabled: s().bool.isRequired,
          icons: p.isRequired,
          id: s().string.isRequired,
          lang: d.isRequired,
          onClick: s().func.isRequired,
          isMoveAll: s().bool
        }), w(R, "defaultProps", {
          isMoveAll: !1
        });
        const j = R;
        function k(e) {
          return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, k(e);
        }
        function S(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function x(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        function E(e, t) {
          return E = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, E(e, t);
        }
        function P(e, t) {
          if (t && ("object" === k(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }
        function C(e) {
          return C = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, C(e);
        }
        var A,
          F,
          T,
          q = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && E(e, t);
            }(l, e);
            var t,
              r,
              n,
              o,
              i = (n = l, o = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  t = C(n);
                if (o) {
                  var r = C(this).constructor;
                  e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return P(this, e);
              });
            function l() {
              return S(this, l), i.apply(this, arguments);
            }
            return t = l, (r = [{
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.controlKey,
                  r = e.disabled,
                  n = e.filterPlaceholder,
                  o = e.filterValue,
                  i = e.id,
                  l = e.lang,
                  a = e.onFilterChange;
                return f().createElement("div", {
                  className: "rdl-filter-container"
                }, f().createElement("label", {
                  className: "rdl-control-label rdl-sr-only",
                  htmlFor: "".concat(i, "-filter-").concat(t)
                }, l["".concat(t, "FilterHeader")]), f().createElement("input", {
                  className: "rdl-filter",
                  "data-key": t,
                  disabled: r,
                  id: "".concat(i, "-filter-").concat(t),
                  placeholder: n,
                  type: "text",
                  value: o,
                  onChange: a
                }));
              }
            }]) && x(t.prototype, r), Object.defineProperty(t, "prototype", {
              writable: !1
            }), l;
          }(f().PureComponent);
        A = q, F = "propTypes", T = {
          controlKey: s().string.isRequired,
          disabled: s().bool.isRequired,
          filterPlaceholder: s().string.isRequired,
          filterValue: s().string.isRequired,
          id: s().string.isRequired,
          lang: d.isRequired,
          onFilterChange: s().func.isRequired
        }, F in A ? Object.defineProperty(A, F, {
          value: T,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : A[F] = T;
        const _ = q;
        function N(e) {
          for (var t = [], r = 0; r < e.length; r += 1) t.push(e[r]);
          return t;
        }
        function D(e) {
          return D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, D(e);
        }
        function L(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        function M(e, t) {
          return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, M(e, t);
        }
        function K(e, t) {
          if (t && ("object" === D(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return B(e);
        }
        function B(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function U(e) {
          return U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, U(e);
        }
        function H(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        var I = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && M(e, t);
          }(a, e);
          var t,
            r,
            n,
            i,
            l = (n = a, i = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = U(n);
              if (i) {
                var r = U(this).constructor;
                e = Reflect.construct(t, arguments, r);
              } else e = t.apply(this, arguments);
              return K(this, e);
            });
          function a(e) {
            var t;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, a), (t = l.call(this, e)).state = {
              value: []
            }, t.onChange = t.onChange.bind(B(t)), t;
          }
          return t = a, r = [{
            key: "onChange",
            value: function (e) {
              var t = N(e.target.options).filter(function (e) {
                return e.selected;
              }).map(function (e) {
                return e.value;
              });
              this.setState({
                value: t
              });
            }
          }, {
            key: "renderFilter",
            value: function () {
              var e = this.props,
                t = e.canFilter,
                r = e.controlKey,
                n = e.disabled,
                o = e.filterPlaceholder,
                i = e.filterValue,
                l = e.id,
                a = e.lang,
                c = e.onFilterChange;
              return t ? f().createElement(_, {
                controlKey: r,
                disabled: n,
                filterPlaceholder: o,
                filterValue: i,
                id: l,
                lang: a,
                onFilterChange: c
              }) : null;
            }
          }, {
            key: "renderSelect",
            value: function () {
              var e = this.props,
                t = e.actions,
                r = e.children,
                n = e.disabled,
                o = e.controlKey,
                i = e.id,
                l = e.inputRef,
                a = e.lang,
                c = e.showNoOptionsText,
                s = e.onDoubleClick,
                u = e.onKeyUp,
                p = this.state.value;
              return c && 0 === f().Children.count(r) ? f().createElement("div", {
                className: "rdl-no-options"
              }, a["no".concat(v(o), "Options")]) : f().createElement("div", {
                className: "rdl-control-container"
              }, t, f().createElement("select", {
                className: "rdl-control",
                disabled: n,
                id: "".concat(i, "-").concat(o),
                multiple: !0,
                ref: l,
                value: p,
                onChange: this.onChange,
                onDoubleClick: s,
                onKeyUp: u
              }, r));
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.controlKey,
                r = e.id,
                n = e.lang,
                i = e.showHeaderLabels,
                l = o()({
                  "rdl-control-label": !0,
                  "rdl-sr-only": !i
                });
              return f().createElement("div", {
                className: "rdl-list-box rdl-".concat(t)
              }, f().createElement("label", {
                className: l,
                htmlFor: "".concat(r, "-").concat(t)
              }, n["".concat(t, "Header")]), this.renderFilter(), this.renderSelect());
            }
          }], r && L(t.prototype, r), Object.defineProperty(t, "prototype", {
            writable: !1
          }), a;
        }(f().Component);
        H(I, "propTypes", {
          canFilter: s().bool.isRequired,
          children: s().node.isRequired,
          controlKey: s().string.isRequired,
          disabled: s().bool.isRequired,
          filterPlaceholder: s().string.isRequired,
          filterValue: s().string.isRequired,
          id: s().string.isRequired,
          inputRef: s().func.isRequired,
          lang: d.isRequired,
          showHeaderLabels: s().bool.isRequired,
          showNoOptionsText: s().bool.isRequired,
          onDoubleClick: s().func.isRequired,
          onFilterChange: s().func.isRequired,
          onKeyUp: s().func.isRequired,
          actions: s().node
        }), H(I, "defaultProps", {
          actions: null
        });
        const V = I,
          W = s().shape({
            label: s().string.isRequired,
            value: s().oneOfType([s().string, s().number]).isRequired,
            disabled: s().bool,
            title: s().string
          }),
          $ = s().arrayOf(s().oneOfType([W, s().shape({
            label: s().node.isRequired,
            options: s().arrayOf(W).isRequired,
            disabled: s().bool,
            title: s().title
          })])),
          J = s().arrayOf(s().oneOfType([s().string, W, s().shape({
            value: s().oneOfType([s().string, s().number]),
            options: s().arrayOf(W)
          })]));
        function Y(e) {
          return Y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, Y(e);
        }
        function z(e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
          }
          return r;
        }
        function G(e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? z(Object(r), !0).forEach(function (t) {
              re(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }
          return e;
        }
        function Q(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        function X(e, t) {
          return X = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, X(e, t);
        }
        function Z(e, t) {
          if (t && ("object" === Y(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return ee(e);
        }
        function ee(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function te(e) {
          return te = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, te(e);
        }
        function re(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        function ne(e) {
          return function (e) {
            if (Array.isArray(e)) return oe(e);
          }(e) || function (e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
          }(e) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return oe(e, t);
              var r = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? oe(e, t) : void 0;
            }
          }(e) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function oe(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
          return n;
        }
        var ie = "middle",
          le = "top",
          ae = function (e, t) {
            return function (r) {
              var n = ne(r),
                o = [n[t], n[e]];
              return n[e] = o[0], n[t] = o[1], n;
            };
          },
          ce = {
            moveLeft: f().createElement("span", {
              className: "fa fa-chevron-left"
            }),
            moveAllLeft: [f().createElement("span", {
              key: 0,
              className: "fa fa-chevron-left"
            }), f().createElement("span", {
              key: 1,
              className: "fa fa-chevron-left"
            })],
            moveRight: f().createElement("span", {
              className: "fa fa-chevron-right"
            }),
            moveAllRight: [f().createElement("span", {
              key: 0,
              className: "fa fa-chevron-right"
            }), f().createElement("span", {
              key: 1,
              className: "fa fa-chevron-right"
            })],
            moveTop: f().createElement("span", {
              className: "fa fa-angle-double-up"
            }),
            moveBottom: f().createElement("span", {
              className: "fa fa-angle-double-down"
            }),
            moveDown: f().createElement("span", {
              className: "fa fa-chevron-down"
            }),
            moveUp: f().createElement("span", {
              className: "fa fa-chevron-up"
            })
          },
          se = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && X(e, t);
            }(s, e);
            var t,
              r,
              n,
              i,
              l,
              c = (i = s, l = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  t = te(i);
                if (l) {
                  var r = te(this).constructor;
                  e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return Z(this, e);
              });
            function s(e) {
              var t;
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, s), (t = c.call(this, e)).state = {
                filter: e.filter ? e.filter : {
                  available: "",
                  selected: ""
                },
                id: e.id || "rdl-".concat(a())
              }, t.onActionClick = t.onActionClick.bind(ee(t)), t.onOptionDoubleClick = t.onOptionDoubleClick.bind(ee(t)), t.onOptionKeyUp = t.onOptionKeyUp.bind(ee(t)), t.onFilterChange = t.onFilterChange.bind(ee(t)), t;
            }
            return t = s, r = [{
              key: "onChange",
              value: function (e, t) {
                var r = this.props,
                  n = r.options,
                  o = r.simpleValue,
                  i = r.onChange,
                  l = t.map(function (e) {
                    return e.value;
                  });
                if (o) i(e, l);else {
                  var a = {
                      selected: [],
                      userSelection: []
                    },
                    c = {
                      selected: e,
                      userSelection: l
                    };
                  Object.keys(c).forEach(function (e) {
                    c[e].forEach(function (t) {
                      n.forEach(function (r) {
                        if (r.value) r.value === t && a[e].push(r);else {
                          var n = [];
                          r.options.forEach(function (e) {
                            e.value === t && n.push(e);
                          }), n.length > 0 && a[e].push({
                            label: r.label,
                            options: n
                          });
                        }
                      });
                    });
                  }), i(a.selected, a.userSelection);
                }
              }
            }, {
              key: "onActionClick",
              value: function (e) {
                var t,
                  r = e.direction,
                  n = e.isMoveAll,
                  o = this.props.options,
                  i = "right" === r,
                  l = i ? this.available : this.selected,
                  a = this.getMarkedOptions(l);
                t = ["up", "down"].indexOf(r) > -1 ? this.rearrangeSelected(a, r) : ["top", "bottom"].indexOf(r) > -1 ? this.moveToExtremes(a, r) : n ? i ? this.makeOptionsSelected(o) : [] : this.toggleSelected(a, i ? "available" : "selected"), this.onChange(t, a);
              }
            }, {
              key: "onOptionDoubleClick",
              value: function (e, t) {
                var r = this.getMarkedOptions(e.currentTarget),
                  n = this.toggleSelected(r, t);
                this.onChange(n, r);
              }
            }, {
              key: "onOptionKeyUp",
              value: function (e, t) {
                var r = e.currentTarget,
                  n = e.keyCode;
                if (this.props.moveKeyCodes.indexOf(n) > -1) {
                  var o = this.getMarkedOptions(r),
                    i = this.toggleSelected(o, t);
                  this.onChange(i, o);
                }
              }
            }, {
              key: "onFilterChange",
              value: function (e) {
                var t = this.props.onFilterChange,
                  r = G(G({}, this.state.filter), {}, re({}, e.target.dataset.key, e.target.value));
                t ? t(r) : this.setState({
                  filter: r
                });
              }
            }, {
              key: "getFlatOptions",
              value: function (e) {
                if (this.props.simpleValue) return e;
                var t = [];
                return e.forEach(function (e) {
                  void 0 !== e.value ? t.push(e.value) : void 0 !== e.options && e.options.forEach(function (e) {
                    t.push(e.value);
                  });
                }), t;
              }
            }, {
              key: "getLabelMap",
              value: function (e) {
                var t = this,
                  r = {};
                return e.forEach(function (e) {
                  void 0 !== e.options ? r = G(G({}, r), t.getLabelMap(e.options)) : r[e.value] = e.label;
                }), r;
              }
            }, {
              key: "getMarkedOptions",
              value: function (e) {
                return null === e ? [] : N(e.options).filter(function (e) {
                  return e.selected;
                }).map(function (e) {
                  return {
                    index: parseInt(e.dataset.index, 10),
                    value: JSON.parse(e.dataset.realValue)
                  };
                });
              }
            }, {
              key: "rearrangeSelected",
              value: function (e, t) {
                var r = this.props.selected,
                  n = this.getFlatOptions(r).slice(0),
                  o = ne(n);
                return 0 === e.length || ("up" === t ? e[e.length - 1].index > e.length - 1 && e.forEach(function (e) {
                  var t = e.index;
                  t > 0 && (o = ae(t, t - 1)(o));
                }) : "down" === t && e[0].index < n.length - e.length && e.reverse().forEach(function (e) {
                  var t = e.index;
                  t < n.length - 1 && (o = ae(t, t + 1)(o));
                })), o;
              }
            }, {
              key: "moveToExtremes",
              value: function (e, t) {
                var r = this.props.selected,
                  n = this.getFlatOptions(r).slice(0),
                  o = ne(n);
                e.forEach(function (e) {
                  var t = e.index;
                  o[t] = null;
                }), o = o.filter(function (e) {
                  return null !== e;
                });
                var i = e.map(function (e) {
                  var t = e.index;
                  return n[t];
                });
                return "top" === t ? [].concat(ne(i), ne(o)) : [].concat(ne(o), ne(i));
              }
            }, {
              key: "makeOptionsSelected",
              value: function (e) {
                var t = this.props.selected,
                  r = this.filterAvailable(e);
                return [].concat(ne(this.getFlatOptions(t)), ne(this.makeOptionsSelectedRecursive(r)));
              }
            }, {
              key: "makeOptionsSelectedRecursive",
              value: function (e) {
                var t = this,
                  r = [];
                return e.forEach(function (e) {
                  void 0 !== e.options ? r = [].concat(ne(r), ne(t.makeOptionsSelectedRecursive(e.options))) : r.push(e.value);
                }), r;
              }
            }, {
              key: "toggleSelected",
              value: function (e, t) {
                var r = this.props,
                  n = r.allowDuplicates,
                  o = r.selected,
                  i = this.getFlatOptions(o).slice(0),
                  l = G({}, i);
                return e.forEach(function (e) {
                  var r = e.value,
                    o = e.index;
                  !(i.indexOf(r) > -1) || n && "selected" !== t ? i.push(r) : delete l[o];
                }), "selected" === t ? Object.keys(l).map(function (e) {
                  return l[e];
                }) : i;
              }
            }, {
              key: "filterOptions",
              value: function (e, t, r) {
                var n = this,
                  o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                  i = this.props,
                  l = i.canFilter,
                  a = i.filterCallback,
                  c = [];
                return e.forEach(function (e) {
                  if (void 0 !== e.options) {
                    var i = n.filterOptions(e.options, t, r, a(e, r));
                    i.length > 0 && c.push(G(G({}, e), {}, {
                      options: i
                    }));
                  } else {
                    var s = [],
                      u = t(e);
                    if (Array.isArray(u) ? u.forEach(function (t) {
                      s.push(G(G({}, e), {}, {
                        selectedIndex: t
                      }));
                    }) : u && s.push(e), s.length > 0) {
                      if (l && !a(e, r) && !o) return;
                      s.forEach(function (e) {
                        c.push(e);
                      });
                    }
                  }
                }), c;
              }
            }, {
              key: "filterAvailable",
              value: function (e) {
                var t = this,
                  r = this.props,
                  n = r.allowDuplicates,
                  o = r.available,
                  i = r.selected,
                  l = this.state.filter.available,
                  a = [];
                return void 0 !== o && a.push(function (e) {
                  return t.getFlatOptions(o).indexOf(e.value) >= 0;
                }), n || a.push(function (e) {
                  return t.getFlatOptions(i).indexOf(e.value) < 0;
                }), this.filterOptions(e, function (e) {
                  return a.reduce(function (t, r) {
                    return t && r(e);
                  }, !0);
                }, l);
              }
            }, {
              key: "filterSelected",
              value: function (e) {
                var t = this,
                  r = this.props,
                  n = r.preserveSelectOrder,
                  o = r.selected,
                  i = this.state.filter.selected;
                return n ? this.filterSelectedByOrder(e) : this.filterOptions(e, function (e) {
                  return function (e, t) {
                    var r = [];
                    return e.forEach(function (e, n) {
                      e === t && r.push(n);
                    }), r;
                  }(t.getFlatOptions(o), e.value);
                }, i);
              }
            }, {
              key: "filterSelectedByOrder",
              value: function (e) {
                var t = this.props,
                  r = t.canFilter,
                  n = t.filterCallback,
                  o = t.selected,
                  i = this.state.filter.selected,
                  l = this.getLabelMap(e),
                  a = this.getFlatOptions(o).map(function (e, t) {
                    return {
                      value: e,
                      label: l[e],
                      selectedIndex: t
                    };
                  });
                return r ? a.filter(function (e) {
                  return n(e, i);
                }).map(function (e, t) {
                  return G(G({}, e), {}, {
                    selectedIndex: t
                  });
                }) : a;
              }
            }, {
              key: "renderOptions",
              value: function (e) {
                var t = this,
                  r = this.props.allowDuplicates,
                  n = this.state.id;
                return e.map(function (e, o) {
                  var i = r ? "".concat(e.value, "-").concat(e.label, "-").concat(o) : "".concat(e.value, "-").concat(e.label);
                  if (void 0 !== e.options) return f().createElement("optgroup", {
                    key: i,
                    disabled: e.disabled,
                    id: "".concat(n, "-optgroup-").concat(e.label),
                    label: e.label,
                    title: e.title
                  }, t.renderOptions(e.options));
                  var l = r ? "".concat(e.value, "-").concat(o) : e.value;
                  return f().createElement("option", {
                    key: i,
                    "data-index": e.selectedIndex,
                    "data-real-value": JSON.stringify(e.value),
                    disabled: e.disabled,
                    id: "".concat(n, "-option-").concat(e.value),
                    title: e.title,
                    value: l
                  }, e.label);
                });
              }
            }, {
              key: "renderListBox",
              value: function (e, t, r, n) {
                var o = this,
                  i = this.props,
                  l = i.alignActions,
                  a = i.canFilter,
                  c = i.disabled,
                  s = i.filterPlaceholder,
                  u = i.lang,
                  p = i.showHeaderLabels,
                  d = i.showNoOptionsText,
                  v = this.state,
                  b = v.filter,
                  y = v.id,
                  h = function (t) {
                    return function (r) {
                      return t(r, e);
                    };
                  };
                return f().createElement(V, {
                  actions: l === le ? n : null,
                  canFilter: a,
                  controlKey: e,
                  disabled: c,
                  filterPlaceholder: s,
                  filterValue: b[e],
                  id: y,
                  inputRef: function (t) {
                    o[e] = t, r && r(t);
                  },
                  lang: u,
                  showHeaderLabels: p,
                  showNoOptionsText: d,
                  onDoubleClick: h(this.onOptionDoubleClick),
                  onFilterChange: h(this.onFilterChange),
                  onKeyUp: h(this.onOptionKeyUp)
                }, t);
              }
            }, {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  r = t.alignActions,
                  n = t.availableRef,
                  i = t.canFilter,
                  l = t.className,
                  a = t.disabled,
                  c = t.icons,
                  s = t.lang,
                  u = t.name,
                  p = t.options,
                  d = t.preserveSelectOrder,
                  v = t.selected,
                  b = t.selectedRef,
                  y = t.showHeaderLabels,
                  h = t.showOrderButtons,
                  g = this.state.id,
                  m = this.renderOptions(this.filterAvailable(p)),
                  O = this.renderOptions(this.filterSelected(p)),
                  w = function (t) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return f().createElement(j, {
                      direction: t,
                      disabled: a,
                      icons: c,
                      id: g,
                      isMoveAll: r,
                      lang: s,
                      onClick: e.onActionClick
                    });
                  },
                  R = f().createElement("div", {
                    className: "rdl-actions-right"
                  }, w("right", !0), w("right")),
                  k = f().createElement("div", {
                    className: "rdl-actions-left"
                  }, w("left"), w("left", !0)),
                  S = o()(G({
                    "react-dual-listbox": !0,
                    "rdl-has-filter": i,
                    "rdl-has-header": y,
                    "rdl-align-top": r === le
                  }, l && re({}, l, !0))),
                  x = this.getFlatOptions(v).join(",");
                return f().createElement("div", {
                  className: S,
                  id: g
                }, this.renderListBox("available", m, n, R), r === ie ? f().createElement("div", {
                  className: "rdl-actions"
                }, R, k) : null, this.renderListBox("selected", O, b, k), d && h ? f().createElement("div", {
                  className: "rdl-actions"
                }, w("top"), w("up"), w("down"), w("bottom")) : null, f().createElement("input", {
                  disabled: a,
                  name: u,
                  type: "hidden",
                  value: x
                }));
              }
            }], n = [{
              key: "getDerivedStateFromProps",
              value: function (e, t) {
                var r = e.filter,
                  n = e.id,
                  o = G({}, t);
                return null !== r && (o.filter = r), null !== n && (o.id = n), o;
              }
            }], r && Q(t.prototype, r), n && Q(t, n), Object.defineProperty(t, "prototype", {
              writable: !1
            }), s;
          }(f().Component);
        re(se, "propTypes", {
          options: $.isRequired,
          onChange: s().func.isRequired,
          alignActions: s().oneOf([ie, le]),
          allowDuplicates: s().bool,
          available: J,
          availableRef: s().func,
          canFilter: s().bool,
          className: s().string,
          disabled: s().bool,
          filter: s().shape({
            available: s().string.isRequired,
            selected: s().string.isRequired
          }),
          filterCallback: s().func,
          filterPlaceholder: s().string,
          icons: p,
          id: s().string,
          lang: d,
          moveKeyCodes: s().arrayOf(s().number),
          name: s().string,
          preserveSelectOrder: s().bool,
          selected: J,
          selectedRef: s().func,
          showHeaderLabels: s().bool,
          showNoOptionsText: s().bool,
          showOrderButtons: s().bool,
          simpleValue: s().bool,
          onFilterChange: s().func
        }), re(se, "defaultProps", {
          alignActions: ie,
          allowDuplicates: !1,
          available: void 0,
          availableRef: null,
          canFilter: !1,
          className: null,
          disabled: !1,
          filter: null,
          filterPlaceholder: "Search...",
          filterCallback: function (e, t) {
            return "" === t || new RegExp(l()(t), "i").test(e.label);
          },
          icons: ce,
          id: null,
          lang: {
            availableFilterHeader: "Filter available",
            availableHeader: "Available",
            moveAllLeft: "Move all left",
            moveAllRight: "Move all right",
            moveLeft: "Move left",
            moveRight: "Move right",
            moveBottom: "Move to bottom",
            moveDown: "Move down",
            moveUp: "Move up",
            moveTop: "Move to top",
            noAvailableOptions: "No available options",
            noSelectedOptions: "No selected options",
            selectedFilterHeader: "Filter selected",
            selectedHeader: "Selected"
          },
          moveKeyCodes: [32, 13],
          name: null,
          preserveSelectOrder: null,
          selected: [],
          selectedRef: null,
          simpleValue: !0,
          showHeaderLabels: !1,
          showNoOptionsText: !1,
          showOrderButtons: !1,
          onFilterChange: null
        });
        const ue = se;
      },
      184: (e, t) => {
        var r;
        !function () {
          "use strict";

          var n = {}.hasOwnProperty;
          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var r = arguments[t];
              if (r) {
                var i = typeof r;
                if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r)) {
                  if (r.length) {
                    var l = o.apply(null, r);
                    l && e.push(l);
                  }
                } else if ("object" === i) if (r.toString === Object.prototype.toString) for (var a in r) n.call(r, a) && r[a] && e.push(a);else e.push(r.toString());
              }
            }
            return e.join(" ");
          }
          e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
            return o;
          }.apply(t, [])) || (e.exports = r);
        }();
      },
      705: (e, t, r) => {
        var n = r(639).Symbol;
        e.exports = n;
      },
      932: e => {
        e.exports = function (e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) o[r] = t(e[r], r, e);
          return o;
        };
      },
      239: (e, t, r) => {
        var n = r(705),
          o = r(607),
          i = r(333),
          l = n ? n.toStringTag : void 0;
        e.exports = function (e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : l && l in Object(e) ? o(e) : i(e);
        };
      },
      531: (e, t, r) => {
        var n = r(705),
          o = r(932),
          i = r(469),
          l = r(448),
          a = n ? n.prototype : void 0,
          c = a ? a.toString : void 0;
        e.exports = function e(t) {
          if ("string" == typeof t) return t;
          if (i(t)) return o(t, e) + "";
          if (l(t)) return c ? c.call(t) : "";
          var r = t + "";
          return "0" == r && 1 / t == -1 / 0 ? "-0" : r;
        };
      },
      957: (e, t, r) => {
        var n = "object" == typeof r.g && r.g && r.g.Object === Object && r.g;
        e.exports = n;
      },
      607: (e, t, r) => {
        var n = r(705),
          o = Object.prototype,
          i = o.hasOwnProperty,
          l = o.toString,
          a = n ? n.toStringTag : void 0;
        e.exports = function (e) {
          var t = i.call(e, a),
            r = e[a];
          try {
            e[a] = void 0;
            var n = !0;
          } catch (e) {}
          var o = l.call(e);
          return n && (t ? e[a] = r : delete e[a]), o;
        };
      },
      333: e => {
        var t = Object.prototype.toString;
        e.exports = function (e) {
          return t.call(e);
        };
      },
      639: (e, t, r) => {
        var n = r(957),
          o = "object" == typeof self && self && self.Object === Object && self,
          i = n || o || Function("return this")();
        e.exports = i;
      },
      522: (e, t, r) => {
        var n = r(833),
          o = /[\\^$.*+?()[\]{}|]/g,
          i = RegExp(o.source);
        e.exports = function (e) {
          return (e = n(e)) && i.test(e) ? e.replace(o, "\\$&") : e;
        };
      },
      469: e => {
        var t = Array.isArray;
        e.exports = t;
      },
      5: e => {
        e.exports = function (e) {
          return null != e && "object" == typeof e;
        };
      },
      448: (e, t, r) => {
        var n = r(239),
          o = r(5);
        e.exports = function (e) {
          return "symbol" == typeof e || o(e) && "[object Symbol]" == n(e);
        };
      },
      833: (e, t, r) => {
        var n = r(531);
        e.exports = function (e) {
          return null == e ? "" : n(e);
        };
      },
      703: (e, t, r) => {
        "use strict";

        var n = r(414);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function () {
          function e(e, t, r, o, i, l) {
            if (l !== n) {
              var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw a.name = "Invariant Violation", a;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var r = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: i,
            resetWarningCache: o
          };
          return r.PropTypes = r, r;
        };
      },
      697: (e, t, r) => {
        e.exports = r(703)();
      },
      414: e => {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      787: t => {
        "use strict";

        t.exports = e;
      }
    },
    r = {};
  function n(e) {
    var o = r[e];
    if (void 0 !== o) return o.exports;
    var i = r[e] = {
      exports: {}
    };
    return t[e](i, i.exports, n), i.exports;
  }
  return n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n(579);
})());